import React from 'react';
import styled from '@emotion/styled';
import { Box, BoxProps, Icon } from '@qga/roo-ui/components';

export const StyledTick = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  background-color: white;
  z-index: 1;
`;

const PackageOptionTick = (props: typeof BoxProps) => (
  <StyledTick
    width={20}
    height={20}
    top={-8}
    right={-8}
    data-testid="PACKAGE_OPTION_TICK"
    {...props}
  >
    <Icon name={'checkCircle'} size={36} />
  </StyledTick>
);

export default PackageOptionTick;
